import { MarketDiscountContent } from './MarketDiscountContent';

export default MarketDiscountContent;
